module.exports = __webpack_public_path__ + "static/media/cheeseburger.fa65cc67.svg";